import styled from 'styled-components';

const RadarContents = styled.svg``;

export { RadarContents };
